import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=fa56be0a"
import script from "./Back.vue?vue&type=script&lang=js"
export * from "./Back.vue?vue&type=script&lang=js"
import style0 from "./Back.vue?vue&type=style&index=0&id=fa56be0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports